import fastConfigurationButtonContainer from './fastConfigurationButtonContainer'
import FastConfigurationButton from './FastConfigurationButton'

export default fastConfigurationButtonContainer(FastConfigurationButton)
